const faqs = [
  {
    title: 'FAQ.WHAT_IS_PARTNER_PROGRAM_TITLE',
    description: 'FAQ.WHAT_IS_PARTNER_PROGRAM_DESCRIPTION',
  },
  {
    title: 'FAQ.WHAT_INCLUDES_TITLE',
    description: 'FAQ.WHAT_INCLUDES_DESCRIPTION',
  },
  {
    title: 'FAQ.FOR_WHOM_IS_TITLE',
    description: 'FAQ.FOR_WHOM_IS_DESCRIPTION',
  },
  {
    title: 'FAQ.ADVANTAGES_TITLE',
    description: 'FAQ.ADVANTAGES_DESCRIPTION',
  },
  {
    title: 'FAQ.WHAT_KIND_OF_TOOL_TITLE',
    description: 'FAQ.WHAT_KIND_OF_TOOL_DESCRIPTION',
  },
  {
    title: 'FAQ.TERMS_TITLE',
    description: 'FAQ.TERMS_DESCRIPTION',
  },
  {
    title: 'FAQ.WHY_CHOOSE_TITLE',
    description: 'FAQ.WHY_CHOOSE_DESCRIPTION',
  },
  {
    title: 'FAQ.PAYMENT_PLANS_TITLE',
    description: 'FAQ.PAYMENT_PLANS_DESCRIPTION',
  },
  {
    title: 'FAQ.WHO_TO_CONTACT_TITLE',
    description: 'FAQ.WHO_TO_CONTACT_DESCRIPTION',
  },
  {
    title: 'FAQ.CAN_ANYONE_TITLE',
    description: 'FAQ.CAN_ANYONE_DESCRIPTION',
  },
  {
    title: 'FAQ.HOW_TO_GET_PAID_TITLE',
    description: 'FAQ.HOW_TO_GET_PAID_DESCRIPTION',
  },
  {
    title: 'FAQ.ACTIVITY_TITLE',
    description: 'FAQ.ACTIVITY_DESCRIPTION',
  },
];

export default {
  faqs,
};



// WEBPACK FOOTER //
// ./src/app/main/faq/constants/faq-constants.js